module.exports = __webpack_public_path__ + "media/coffee-preferences/acidity_none-f1748da3.png";